export enum ModalActionTypes {
  TOGGLE = "TOGGLE",
}
